"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ZoomRoomApplianceOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ZoomRoomApplianceOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2.25a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 0a1.75 1.75 0 1 0 0 3.5h10.5a1.75 1.75 0 1 0 0-3.5H2.75Zm0 1h10.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2.5a.5.5 0 0 0 1 0V6a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h4.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-1-1V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.136 10.682C8 10.95 8 11.3 8 12v2c0 .7 0 1.05.136 1.318.12.235.311.426.547.546C8.95 16 9.3 16 10 16h4c.7 0 1.05 0 1.318-.136a1.25 1.25 0 0 0 .546-.546C16 15.05 16 14.7 16 14v-2c0-.7 0-1.05-.136-1.318a1.25 1.25 0 0 0-.546-.546C15.05 10 14.7 10 14 10h-4c-.7 0-1.05 0-1.317.136a1.25 1.25 0 0 0-.547.546ZM10 11h4c.367 0 .581 0 .74.014.08.006.118.014.132.018a.25.25 0 0 1 .096.096.887.887 0 0 1 .018.132c.013.159.014.373.014.74v2c0 .367 0 .581-.014.74a.887.887 0 0 1-.018.132.25.25 0 0 1-.096.096.887.887 0 0 1-.132.018C14.58 15 14.367 15 14 15h-4c-.367 0-.581 0-.74-.014a.885.885 0 0 1-.132-.018.25.25 0 0 1-.096-.096.87.87 0 0 1-.018-.132A10.386 10.386 0 0 1 9 14v-2c0-.367 0-.581.014-.74a.87.87 0 0 1 .018-.132.25.25 0 0 1 .096-.096.885.885 0 0 1 .132-.018C9.42 11 9.633 11 10 11Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ZoomRoomApplianceOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ZoomRoomApplianceOutline;
exports["default"] = _default;